var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var moment = require('moment');
var _ = require('lodash');
var Line = require('react-chartjs-2').Line;
require('chartjs-plugin-annotation');
var utils = require('../../../../utils/utils');
var dashboardUtils = require('../../utils');

var LineChart = createReactClass({
    mixins: [PureRenderMixin],

    buildChartData: function() {
        var timestamps = this.getTimestamps();
        var datasets = this.getDatasets(timestamps);
        var isSmallScreen = utils.isSmallScreen();
        var isTrendOnSmallScreen = this.props.isTrend && isSmallScreen;

        var labels = timestamps.map(function(timestamp){
            return isSmallScreen ? moment(timestamp).format("M/D") : moment(timestamp).format("MMM D")
        });
        if(isTrendOnSmallScreen){
            labels = _.fill(Array(7 - labels.length), '').concat(labels)
        }
        labels.unshift('');
        labels.push('');

        var pointRadius = this.getPointRadius(timestamps.length, 5);
        if(isTrendOnSmallScreen){
            pointRadius = _.fill(Array(7 - pointRadius.length), 0).concat(pointRadius)
        }
        pointRadius.unshift(0);
        pointRadius.push(0);

        datasets.forEach(function(dataset){
            if(isTrendOnSmallScreen){
                dataset.data = _.fill(Array(7 - dataset.data.length), NaN).concat(dataset.data)
            }
            dataset.data.unshift(NaN);
            dataset.data.push(NaN);
            dataset.pointRadius = dataset.pointHoverRadius = pointRadius;
        });

        return {
            labels: labels,
            datasets: datasets
        };
    },

    getTimestamps: function(){
        var itemScoresDataList = this.props.itemScoresDataList;
        var timestamps = [];

        if(itemScoresDataList.length === 1){
            timestamps = itemScoresDataList[0].scores.map(function(score){
                return score.timestamp;
            });
        }else if(itemScoresDataList.length > 1){
            itemScoresDataList.forEach(function(itemScoresData){
                timestamps = timestamps.concat(itemScoresData.scores.map(function(score){
                    return score.timestamp;
                }));
                timestamps = _.uniq(timestamps);
                if(timestamps.length > 1){
                    timestamps.sort(function(timestampA, timestampB){
                        return moment(timestampA).isAfter(timestampB);
                    });
                }
            });
        }
        timestamps = timestamps.slice(-7);

        return timestamps;
    },

    getDatasets: function(timestamps){
        var itemScoresDataList = this.props.itemScoresDataList;
        var datasets = [];

        var isMultiple = itemScoresDataList.length > 1;
        itemScoresDataList.forEach(function(itemScoresData){
            var dataset = {
                label: itemScoresData.displayName,
                data: timestamps.map(function(timestamp){
                    return itemScoresData.timestamp2Score[timestamp] || NaN;
                }),
                pointBorderWidth: 2,
                pointBorderColor: '#fff',
                pointHoverBorderWidth: 2,
                pointHoverBorderColor: '#fff',
                fill: false
            };

            if(isMultiple){
                dataset.borderColor
                    = dataset.pointBackgroundColor
                    = dataset.pointHoverBackgroundColor
                    = dashboardUtils.getColorFromDashboardGradientBasedOnPercentile(itemScoresData.scores[itemScoresData.scores.length - 1].percentile)
            }
            datasets.push(dataset);
        });

        return datasets;
    },

    getPointRadius: function(length, size){
        var pointRadius = [];

        for(var i = 1; i <= length; i++){
            if(i !== length){
                pointRadius.push(this.props.isTrend ? 0 : size)
            }else{
                pointRadius.push(this.props.isTrend ? size : size + 1);
            }
        }

        return pointRadius;
    },

    getChartOptions: function(numDates) {
        var isReallySmallScreen = utils.isSmallScreen();

        var lineTension = this.props.isTrend ? 0.4 : 0;
        var shouldShowAxes = this.props.isTrend ? false : true;

        return {
            spanGaps: false,
            elements: {
              line: {
                tension: lineTension, // disables bezier curves
              }
            },
            layout: {
                padding: {
                    top: 3,
                    right: this.props.isTrend ? 11 : 0, // avoid annotation label clipped
                    bottom: 3
                }
            },
            animation: {
              duration: 0 // general animation time
            },
            hover: {
              animationDuration: 0 // duration of animations when hovering an item
            },
            maintainAspectRatio: false,
            responsiveAnimationDuration: 0, // animation duration after a resize
            scales: {
              xAxes: [{
                display: shouldShowAxes,
                gridLines: {
                  display: false,
                  offsetGridLines: numDates > 1 ? false : true // chartjs bug "fix" for single points: https://github.com/chartjs/Chart.js/issues/4037
                },
                ticks: {
                  autoSkip: false
                }
              }],
              yAxes: [{
                display: shouldShowAxes && (isReallySmallScreen ? false : true),
                id: 'y-axis-0',
                gridLines: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  fontColor: 'lightgray',
                  max: 105, /* yAxes max min for avoiding line clipped at the edge */
                  min: -5,
                  beginAtZero: true,
                  stepSize: 25,
                  callback: function(value, index, values) {
                    return value <= 0 || value >= 100 ? '' : '' + value;
                  }
                }
              }]
            },
            legend: {
              display: false
            },
            tooltips: {
              enabled: false
            },
            annotation: this.buildChartAnnotation(isReallySmallScreen)
        };
    },

    buildChartAnnotation: function(isReallySmallScreen){
        var annotationPosition = isReallySmallScreen ? 'left' : 'right';
        var shouldShowAnnotationLabel = this.props.isTrend ? false : true;

        return {
          drawTime: 'beforeDatasetsDraw',
          annotations: [{ // label for 25, for acheiving label vertical align center
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: 12.5,
              borderColor: 'transparent',
              borderWidth: 0,
              label: {
                backgroundColor: 'transparent',
                fontStyle: "normal",
                fontColor: "lightgray",
                xPadding: 10,
                cornerRadius: 0,
                position: annotationPosition,
                enabled: shouldShowAnnotationLabel,
                content: "Mild"
              }
            },{
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 25,
            borderColor: 'lightgray',
            borderWidth: 0.5,
            borderDash: [3, 3],
            borderDashOffset: 0,
            label: {
              backgroundColor: 'transparent',
            }
            },{ // label for 50
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: 37.5,
              borderColor: 'transparent',
              borderWidth: 0,
              label: {
                backgroundColor: 'transparent',
                fontStyle: "300",
                fontColor: "lightgray",
                xPadding: 10,
                cornerRadius: 0,
                position: annotationPosition,
                enabled: shouldShowAnnotationLabel,
                content: "Moderate"
              }
            },{
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 50,
            borderColor: 'lightgray',
            borderWidth: 0.5,
            borderDash: [3, 3],
            borderDashOffset: 0,
            label: {
              backgroundColor: 'transparent',
            }
        },{ // label for 75
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: 62.5,
              borderColor: 'transparent',
              borderWidth: 0,
              label: {
                backgroundColor: 'transparent',
                fontStyle: "300",
                fontColor: "lightgray",
                xPadding: 10,
                cornerRadius: 0,
                position: annotationPosition,
                enabled: shouldShowAnnotationLabel,
                content: "Severe"
              }
          },{
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 75,
            borderColor: 'lightgray',
            borderWidth: 0.5,
            borderDash: [3, 3],
            borderDashOffset: 0,
            label: {
              backgroundColor: 'transparent',
            }
        },{ // label for 100
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: 87.5,
              borderColor: 'transparent',
              borderWidth: 0,
              label: {
                backgroundColor: 'transparent',
                fontStyle: "300",
                fontColor: "lightgray",
                xPadding: 10,
                cornerRadius: 0,
                position: annotationPosition,
                enabled: shouldShowAnnotationLabel,
                content: "Extreme"
              }
            },{
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 100,
            borderColor: 'transparent',
            borderWidth: 0,
            borderDash: [3, 3],
            borderDashOffset: 0,
            label: {
              backgroundColor: 'transparent',
            }
          }]
      };
    },

    getChartPlugins: function(){
        // dynamic change plugins have no effect, so I move this logic to updateChartGradient for the moment
        var pluginObj = {
            afterLayout: function(chartInstance){
                dashboardUtils.updateChartGradient(chartInstance);
            }
        }

        if(this.props.isTrend){
            pluginObj.afterRender = function (chartInstance){
                  var ctx = chartInstance.chart.ctx;

                  // render the value of the chart above the bar
                  ctx.font = Chart.helpers.fontString(14, 'normal normal', Chart.defaults.global.defaultFontFamily); // eslint-disable-line
                  ctx.fillStyle = 'black';
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'bottom';

                  chartInstance.data.datasets.forEach(function(dataset){
                      var model = dataset._meta[Object.keys(dataset._meta)[0]].data[dataset.data.length - 2]._model;
                      ctx.fillText(dataset.data[dataset.data.length - 2], model.x + 16, model.y + 9);
                  });
            };
        }

        return [pluginObj];
    },

    render: function(){
        var data = this.buildChartData();
        return (
            <Line data={data} options={this.getChartOptions(data.labels && data.labels.length)} plugins={this.getChartPlugins()} />
        )
    }
});

module.exports = LineChart;


// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/lineChart.jsx